import styled from 'styled-components';

export const ContainerBgWhite = styled.div`
  background-color: white;
  padding: 10px;
`;
